import clsx from 'clsx';
import { useContext, useEffect } from 'react';
import Text from '../text';
import { DataTableContainerContext, ICheckDontSaveChange, IDataTableContext, IFocusCell, IRangeSelectionProps } from './DataTable';
import styles from "./DataTable.module.css";
interface ICellProps {

    cell: any,
    focusedCell?: IFocusCell,
    rowIndex: number,
    checkDontSaveChange?: ICheckDontSaveChange,
    onFocuseCellChanged?: (data: IFocusCell) => void,
    selectedCells: any,
    rangeSelection?: IRangeSelectionProps,
    handleMouseDown: (rowIndex: number, colIndex: number) => void,
    handleMouseMove: (rowIndex: number, colIndex: number) => void,
    rowId: any,
    rowData: any,
    isRowSelectedSingle: boolean,
    colIndex: number;
    isHaveFocusedCell?: boolean
}
const Cell = (props: ICellProps) => {
    const { cell, handleMouseDown, handleMouseMove, rowId, rowData, isRowSelectedSingle, onFocuseCellChanged, colIndex, isHaveFocusedCell, selectedCells, rowIndex } = props;
    const { props: tableProps, allColumns } = useContext<IDataTableContext>(DataTableContainerContext);
    let isDontSave: boolean = false;
    if (
        props.checkDontSaveChange &&
        cell.column.isAllowFocus
    ) {
        const rootRowData =
            props.checkDontSaveChange.rootDataSource.find(
                (x) => x.id === rowId
            );
        if (rootRowData) {
            const rootValue =
                rootRowData[cell.column.dataField];
            const currentValue =
                rowData[cell.column.dataField];
            if (rootValue !== currentValue) {
                isDontSave = true;
            }
        }
    }
    // Check if this column should be fixed
    const isFixedColumn = tableProps.fixedLeftColumns && colIndex < tableProps.fixedLeftColumns;
    let leftPosition = 0;
    if (isFixedColumn) {
        // Calculate left position for fixed columns
        for (let i = 0; i < colIndex; i++) {
            const prevColumn = allColumns[i];
            const width = prevColumn.width || '120px';
            leftPosition += parseInt(width.toString().replace('px', '')) || 120;
        }
    }

    const cellStyle = {
        width: cell.column.width,
        minWidth: cell.column.minWidth,
        fontWeight: cell.column.isMainColumn ? "600" : 400,
        whiteSpace: "break-spaces" as const,
        textAlign: cell.column.align,
        ...(isRowSelectedSingle && { backgroundColor: "#fff8c5" }),
        ...(rowData && { color: rowData.backgroundColor }),
        ...(isFixedColumn && { left: `${leftPosition}px` }),
    };
    const handleFocus = cell.column.isAllowFocus && onFocuseCellChanged
        ? () => onFocuseCellChanged({
            rowData: rowData,
            dataField: cell.column.dataField,
        })
        : undefined;
    return (
        <td
            {...cell.getCellProps()}
            key={colIndex}
            style={cellStyle}
            tabIndex={
                cell.column.isAllowFocus ? 0 : undefined
            }
            onFocus={handleFocus}
            className={clsx(
                props.focusedCell && isHaveFocusedCell && props.focusedCell.dataField === cell.column.dataField
                    ? styles.focused
                    : "",
                isDontSave ? styles.isDoneSave : "",
                selectedCells.has(`${rowIndex}-${colIndex}`) ? styles.rangeSelected : "",
                isFixedColumn ? styles.fixed_column : ""
            )}
            onMouseDown={props.rangeSelection ? () => handleMouseDown(rowIndex, colIndex) : undefined}
            onMouseMove={props.rangeSelection ? () => handleMouseMove(rowIndex, colIndex) : undefined}
        >
            {/* {cell.column.isHideZeroValue ?
                <>
                    {rowData[cell.column.dataField]?.toString() === "0" ? "" : cell.render("Cell")}
                </>
                :
                <>
                    {cell.column.cellRender
                        ? cell.column.cellRender(rowData)
                        : cell.render("Cell")}
                </>
            } */}
            {cell.column.cellRender
                ? cell.column.cellRender(rowData)
                : <Text
                    text={
                        (cell.column.isHideZeroValue && rowData[cell.column.dataField]?.toString() === "0")
                            ? ""
                            : (rowData[cell.column.dataField]?.toString() ?? "")
                    }
                />
            }

        </td>
    );
};

export default Cell;